<template>
    <GmapMap
        :center="initMap.coordinates"
        :zoom="initMap.zoom"
        :map-type-id="initMap.type"
        :options="initMap.options"
        style="width: 100%; height: 100%;"
        classes="gmap-cl"
        ref="googleMap">
        <GmapMarker :key="1"
                    :position="marker.coordinates"
                    v-if="marker.show"/>
        <GmapCircle
            :center="marker.coordinates"
            :radius="circle.radius"
            :options="circle.options"
            v-if="circle.show"
        ></GmapCircle>
        <GmapPolygon :options="polygon.options"
                     v-if="polygon.show"></GmapPolygon>
    </GmapMap>
</template>

<script>
import { EventBus } from "@widget/plugins/event-bus";

export default {
    name: "google-map",
    props: {
        type: String,
        markerProp: Object,
        zoom: Number,
        radius: Number,
        markerType: String
    },
    methods: {
        initPolygons () {
            this.$refs.googleMap.$mapPromise.then(() => {
                this.drawingManager = new google.maps.drawing.DrawingManager({
                    drawingMode: google.maps.drawing.OverlayType.POLYGON,
                    drawingControl: false,
                    polygonOptions: {
                        fillColor: "#37AAD2",
                        fillOpacity: 0.7,
                        strokeColor: "#0E5F93",
                        strokeWeight: 3,
                        zIndex: 1
                    }
                });
                this.drawingManager.setMap(this.$refs.googleMap.$mapObject);
                google.maps.event.addListener(this.drawingManager, "overlaycomplete", (event) => {
                    this.allShapes.push(event);
                    let area = google.maps.geometry.spherical.computeArea(event.overlay.getPath());
                    this.$emit("set-polygon", {
                        coordinates: event.overlay.getPath(),
                        area: this.formatArea(area),
                        countPolygon: this.allShapes.length
                    });
                });
            });
        },
        removePolygons () {
            if (this.drawingManager) {
                for (let i = 0; i < this.allShapes.length; i++) {
                    this.allShapes[i].overlay.setMap(null);
                }
                this.allShapes = [];
                this.drawingManager.setMap(null);
            }
        },
        removePolygon (polygons) {
            if (this.drawingManager) {
                for (let i = 0; i < this.allShapes.length; i++) {
                    if (this.getPathString(this.allShapes[i].overlay.getPath()) === polygons) {
                        this.allShapes[i].overlay.setMap(null);

                        this.$delete(this.allShapes, i);
                    }
                }
            }
        },
        formatArea (n) {
            n *= 0.0000003861006141353;
            return n.toFixed(1).replace(/(\d)(?=(\d{3})+\.)/g, "$1,") + " sq. miles";
        },
        getPathString (inPath) {
            let coords = [],
                path = inPath.getArray(),
                path0 = path[0];
            path.forEach((item) => {
                coords.push(item.lat() + " " + item.lng());
            });
            coords.push(path0.lat() + " " + path0.lng());
            return coords.join(",");
        },
        resetMap () {
            this.initMap.coordinates = { lat: 38.78658, lng: -96.981594 };
            this.initMap.zoom = 4;
            this.circle.show = false;
            this.circle.radius = 0;
            this.marker.show = false;
            this.marker.coordinates = { lat: 0, lng: 0 };
            this.polygon.show = false;
        }
    },
    watch: {
        type () {
            this.resetMap();

            if (this.type === "mapping") {
                this.polygon.show = true;
                this.initPolygons();
            } else {
                this.removePolygons();
            }
        },
        markerProp () {
            this.marker = {
                coordinates: this.markerProp,
                show: true
            };
            this.initMap.coordinates = this.markerProp;
            if (this.markerType === "state") {
                this.initMap.zoom = 5;
            } else if (this.markerType === "county") {
                this.initMap.zoom = 7;
            } else {
                if (this.radius <= 5) {
                    this.initMap.zoom = 12;
                } else if (this.radius > 5 && this.radius <= 10) {
                    this.initMap.zoom = 10;
                } else if (this.radius > 10 && this.radius <= 25) {
                    this.initMap.zoom = 10;
                } else if (this.radius > 25 && this.radius <= 50) {
                    this.initMap.zoom = 8;
                } else if (this.radius > 50 && this.radius <= 250) {
                    this.initMap.zoom = 6;
                } else if (this.radius > 250) {
                    this.initMap.zoom = 4;
                }
            }

            this.circle.radius = this.radius * 1609;
            this.circle.show = true;
        },
        zoom () {
            this.initMap.zoom = this.zoom;
        },
        radius () {
            this.circle.radius = this.radius * 1609;
            this.circle.show = true;
        },
        "allShapes.length" () {
            if (!this.allShapes.length) {
                this.resetMap();
            }
        }
    },
    data () {
        return {
            initMap: {
                zoom: this.zoom,
                type: "roadmap",
                coordinates: {
                    lat: 38.78658,
                    lng: -96.981594
                },
                options: {
                    fullscreenControl: false,
                    rotateControl: false,
                    streetViewControl: false,
                    mapTypeControl: false,
                    disableDefaultUi: true,
                    styles: [
                        {
                            "featureType": "administrative",
                            "elementType": "labels.text.fill",
                            "stylers": [
                                {
                                    "color": "#444444"
                                }
                            ]
                        },
                        {
                            "featureType": "landscape",
                            "elementType": "all",
                            "stylers": [
                                {
                                    "color": "#f2f2f2"
                                }
                            ]
                        },
                        {
                            "featureType": "poi",
                            "elementType": "all",
                            "stylers": [
                                {
                                    "visibility": "off"
                                }
                            ]
                        },
                        {
                            "featureType": "poi",
                            "elementType": "labels.text",
                            "stylers": [
                                {
                                    "visibility": "off"
                                }
                            ]
                        },
                        {
                            "featureType": "road",
                            "elementType": "all",
                            "stylers": [
                                {
                                    "saturation": -100
                                },
                                {
                                    "lightness": 45
                                }
                            ]
                        },
                        {
                            "featureType": "road.highway",
                            "elementType": "all",
                            "stylers": [
                                {
                                    "visibility": "simplified"
                                }
                            ]
                        },
                        {
                            "featureType": "road.arterial",
                            "elementType": "labels.icon",
                            "stylers": [
                                {
                                    "visibility": "off"
                                }
                            ]
                        },
                        {
                            "featureType": "transit",
                            "elementType": "all",
                            "stylers": [
                                {
                                    "visibility": "off"
                                }
                            ]
                        },
                        {
                            "featureType": "water",
                            "elementType": "all",
                            "stylers": [
                                {
                                    "color": "#dbdbdb"
                                },
                                {
                                    "visibility": "on"
                                }
                            ]
                        }
                    ]
                }
            },
            polygon: {
                show: false,
                options: {
                    fillColor: "#37AAD2",
                    fillOpacity: 0.7,
                    strokeColor: "#0E5F93",
                    strokeOpacity: 0.7,
                    strokeWeight: 3,
                    clickable: false,
                    editable: false,
                    zIndex: 1
                }
            },
            circle: {
                radius: 0,
                show: false,
                options: {
                    fillColor: "#2D6F24",
                    fillOpacity: 0.3,
                    strokeColor: "#2D6F24",
                    strokeOpacity: 0.3,
                    strokeWeight: 1
                }
            },
            marker: {
                coordinates: {
                    lat: 0,
                    lng: 0
                },
                show: false
            },
            hideRadius: false,
            drawingManager: null,
            allShapes: []
        };
    },
    mounted () {
        EventBus.$on(["reset-map", "remove-select", "remove-marker"], () => {
            this.resetMap();
        });

        EventBus.$on("remove-polygon", polygons => {
            this.removePolygon(polygons);
        });

        if (this.type === "mapping") {
            this.polygon.show = true;
            this.initPolygons();
        } else {
            this.removePolygons();
        }
    }
};
</script>
<style scoped lang="scss">
.gmap-cl{
    height: 100%;
    @media (min-width: 1024px){
        height: 70%;
    }
}
</style>
